import { parseSingleValueSelect } from './SingleValueSelectFilter';

export const INTERVIEWER_QUERY_PARAM = 'interviewer';

export function parseInterviewer() {
  return parseSingleValueSelect(INTERVIEWER_QUERY_PARAM);
}
